import { render, staticRenderFns } from "./VDatepicker.vue?vue&type=template&id=fdb92564&lang=pug"
import script from "./VDatepicker.vue?vue&type=script&lang=js"
export * from "./VDatepicker.vue?vue&type=script&lang=js"
import style0 from "./VDatepicker.vue?vue&type=style&index=0&id=fdb92564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports